// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateDocumentFromS3DTO } from '../models';
import { DocumentDTO } from '../models';
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a document
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument(file: any, name: string, type: string, options: any = {}): RequestArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling createDocument.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling createDocument.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling createDocument.');
            }
            const localVarPath = `/v2/documents`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a document from s3
         * @param {CreateDocumentFromS3DTO} createDocumentFromS3DTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromS3(createDocumentFromS3DTO: CreateDocumentFromS3DTO, options: any = {}): RequestArgs {
            // verify required parameter 'createDocumentFromS3DTO' is not null or undefined
            if (createDocumentFromS3DTO === null || createDocumentFromS3DTO === undefined) {
                throw new RequiredError('createDocumentFromS3DTO','Required parameter createDocumentFromS3DTO was null or undefined when calling createFromS3.');
            }
            const localVarPath = `/v2/documents/from-s3`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateDocumentFromS3DTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createDocumentFromS3DTO !== undefined ? createDocumentFromS3DTO : {}) : (createDocumentFromS3DTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get documents by ids
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsByIds(ids: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling getDocumentsByIds.');
            }
            const localVarPath = `/v2/documents`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a document
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument(file: any, name: string, type: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDTO> {
            const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).createDocument(file, name, type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create a document from s3
         * @param {CreateDocumentFromS3DTO} createDocumentFromS3DTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromS3(createDocumentFromS3DTO: CreateDocumentFromS3DTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDTO> {
            const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).createFromS3(createDocumentFromS3DTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get documents by ids
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsByIds(ids: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDTO>> {
            const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).getDocumentsByIds(ids, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create a document
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument(file: any, name: string, type: string, options?: any) {
            return DocumentsApiFp(configuration).createDocument(file, name, type, options)(axios, basePath);
        },
        /**
         * Create a document from s3
         * @param {CreateDocumentFromS3DTO} createDocumentFromS3DTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromS3(createDocumentFromS3DTO: CreateDocumentFromS3DTO, options?: any) {
            return DocumentsApiFp(configuration).createFromS3(createDocumentFromS3DTO, options)(axios, basePath);
        },
        /**
         * Get documents by ids
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsByIds(ids: Array<string>, options?: any) {
            return DocumentsApiFp(configuration).getDocumentsByIds(ids, options)(axios, basePath);
        },
    };
};

/**
 * DocumentsApi - interface
 * @export
 * @interface DocumentsApi
 */
export interface DocumentsApiInterface {
    /**
     * Create a document
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    createDocument(file: any, name: string, type: string, options?: any): AxiosPromise<DocumentDTO>;

    /**
     * Create a document from s3
     * @param {CreateDocumentFromS3DTO} createDocumentFromS3DTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    createFromS3(createDocumentFromS3DTO: CreateDocumentFromS3DTO, options?: any): AxiosPromise<DocumentDTO>;

    /**
     * Get documents by ids
     * @param {Array<string>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentsByIds(ids: Array<string>, options?: any): AxiosPromise<Array<DocumentDTO>>;

}

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI implements DocumentsApiInterface {
    /**
     * Create a document
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public createDocument(file: any, name: string, type: string, options?: any) {
        return DocumentsApiFp(this.configuration).createDocument(file, name, type, options)(this.axios, this.basePath);
    }

    /**
     * Create a document from s3
     * @param {CreateDocumentFromS3DTO} createDocumentFromS3DTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public createFromS3(createDocumentFromS3DTO: CreateDocumentFromS3DTO, options?: any) {
        return DocumentsApiFp(this.configuration).createFromS3(createDocumentFromS3DTO, options)(this.axios, this.basePath);
    }

    /**
     * Get documents by ids
     * @param {Array<string>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentsByIds(ids: Array<string>, options?: any) {
        return DocumentsApiFp(this.configuration).getDocumentsByIds(ids, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for DocumentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create a document
 * @param {any} file 
 * @param {string} name 
 * @param {string} type 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createDocument(
    file: any,
    name: string,
    type: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<DocumentDTO> {
    const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).createDocument(file, name, type, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create a document from s3
 * @param {CreateDocumentFromS3DTO} createDocumentFromS3DTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createFromS3(
    createDocumentFromS3DTO: CreateDocumentFromS3DTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<DocumentDTO> {
    const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).createFromS3(createDocumentFromS3DTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get documents by ids
 * @param {Array<string>} ids 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getDocumentsByIds(
    ids: Array<string>,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<DocumentDTO>> {
    const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).getDocumentsByIds(ids, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

